import React from "react";

const ValidationPopup = ({
  isValidationPopup,
  handleCloseValidationModal,
  selectedLanguage,
  duplicateInFile,
  emailLeanghtValidation,
  invalidEmailsWithoutDotCom,
  localpartValiadation,
  longDomainEmails,
  longFirstName,
  longLastName,
  invalidMobileNumbers,
  unauthorizedCountryCodes,
  duplicateMobileNumbers,
  missingMobileNumbers,
  missingCountryCodes,
  longReference,
  longDescription = [],
  inValidAuthType,
  inValidMsgForBoth,
  invalidCanPrintValues,
  exceedMaxPrintsPerDoc,
  maxPrintsWithoutCanPrint,
  canPrintNotEnabledAtDocLevel,
  maxPrintsExceedLimit,
  invalidMaxPrintsValues,
  invalidDomain = [],
  missingRequiredFields = [],
  dlEmailValidation = []
}) => {
  if (!isValidationPopup) return null;

  let counter = 1;

  return (
    <div
      className="modalCus documentversion-history"
      id="myModal"
      style={{ zIndex: 1078 }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="card-body pt-1">
            <div
              className="mb-2 mt-3 justify-content-between d-flex"
              style={{ borderBottom: "2px solid #918d8d4d" }}>
              <h4 htmlFor="">
                <p className="fw-bold">
                  {selectedLanguage.LstLanguageCodes.UI_AuthgerizedTReaders}
                </p>
              </h4>
              <button
                type="button"
                className="btn btn-outline-danger modalclose download"
                onClick={(e) => handleCloseValidationModal()}>
                <span className="material-icons font-20">
                  highlight_off
                </span>
              </button>
            </div>
            <div className="row">
              <div>
                <p className="IssuesUploadMsg">
                  {
                    selectedLanguage.LstLanguageCodes
                      .UI_ThefileYouAreTryingToUpload
                  }
                </p>
              </div>
            </div>
            <div
              className="card-body pt-0"
              style={{
                maxHeight: "350px",
                overflow: "auto",
                overflowX: "hidden",
                display: "block",
                paddingRight: "3px",
                marginTop: "-28px",
                marginRight: "10px",
              }}>
              <div className="table-responsive res-card">
                <table
                  className="fold-table table tablelayoutValidation "
                  cellPadding="0"
                  cellSpacing="0">
                  <thead className="bg-lightblue">
                    <tr className="">
                      <th className="" style={{ width: "19%" }}>
                        {selectedLanguage.LstLanguageCodes.UI_Sno}
                      </th>
                      <th className="" style={{ width: "33%" }}>
                        {selectedLanguage.LstLanguageCodes.UI_Inputvalue}
                      </th>
                      <th className="">
                        {selectedLanguage.LstLanguageCodes.UI_Issue}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {duplicateEmails.map((email, index) => (
                      <tr className="borderrow">
                      <td >{counter++}</td>
                     <td>{email}</td>
                     <td >Duplicate email address</td>
                     </tr>
                   ))} */}
                    {missingRequiredFields.map((item, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{item.value}</td>
                        <td>{item.issue}</td>
                      </tr>
                    ))}
                    {duplicateInFile.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email}</td>
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_DuplicateEmailAdress
                          }
                        </td>
                      </tr>
                    ))}
                    {emailLeanghtValidation.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email.email}</td>
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_EmailAdressContainsMoreThan255
                          }
                        </td>
                      </tr>
                    ))}
                    {invalidEmailsWithoutDotCom.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email.email}</td>

                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_InvalidEmailAdress
                          }
                        </td>
                      </tr>
                    ))}
                    {(dlEmailValidation || []).map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email.email}</td>
                        <td>{selectedLanguage?.LstLanguageCodes?.UI_CannotAddDLAsAuthorizedReader}</td>
                      </tr>
                    ))}
                    {invalidDomain.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email.email}</td>

                        <td>
                          {
                            selectedLanguage?.LstLanguageCodes?.UI_PleaseEnterValidDomainName ||
                            "Invalid domain entered."
                          }
                        </td>
                      </tr>
                    ))}
                    {localpartValiadation.map((email, index) => (
                      <tr className="borderrow">
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email.email}</td>
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_LocalPartofEmailContainsMorethan64
                          }
                        </td>
                      </tr>
                    ))}
                    {longDomainEmails.map((email, index) => (
                      <tr className="borderrow">
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email.email}</td>
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_DomainContainsMoreThan190
                          }
                        </td>
                      </tr>
                    ))}
                    {longFirstName.map((email, index) => (
                      <tr className="borderrow">
                        <td>{counter++}</td>
                        <td>{email.firstName}</td>
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_FirstNameMoreThanFifty
                          }{" "}
                        </td>
                      </tr>
                    ))}
                    {longLastName.map((email, index) => (
                      <tr className="borderrow">
                        <td>{counter++}</td>
                        <td>{email.lastName}</td>
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_LastNameMoreThanFifty
                          }{" "}
                        </td>
                      </tr>
                    ))}
                    {longReference.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{email.reference}</td>
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_ReferenceMoreThanFifty
                          }{" "}
                        </td>
                      </tr>
                    ))}
                    {longDescription.map((item, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td className="wordbreakPopup">{item.description}</td>
                        <td>{selectedLanguage?.LstLanguageCodes?.UI_DescriptionCharacterLimit}</td>
                      </tr>
                    ))}
                    {inValidAuthType.map((type, index) => (
                      <tr className="borderrow">
                        <td>{counter++}</td>
                        <td>{type}</td>
                        {type.toLowerCase() === "text" ? (
                          <td>
                            {
                              selectedLanguage.LstLanguageCodes
                                .UI_OptionToSendPasscodeByText
                            }{" "}
                          </td>) : (type.toLowerCase() === "email") ? (
                            <td>
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_OptionToSendPasscodeByEmail
                              }{" "}
                            </td>
                          ) : (type.toLowerCase() === "both") ? (
                            <td>
                              {
                                inValidMsgForBoth
                              }{" "}
                            </td>
                          ) : (<><td>
                            {
                              selectedLanguage.LstLanguageCodes
                                .UI_InvalidOption
                            }{" "}
                          </td></>)
                        }
                      </tr>
                    ))}
                    {invalidMobileNumbers.map((email, index) => (
                      <tr className="borderrow">
                        <td>{counter++}</td>
                        {/* <td>{row[3]}</td> Country Code */}
                        <td>{email.mobileNumber}</td> {/* Mobile Number */}
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_EnterValidMobileNum
                          }
                        </td>
                      </tr>
                    ))}
                    {unauthorizedCountryCodes.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>
                          {email.mobileCountryCode?.value === undefined
                            ? email.mobileCountryCode
                            : email.mobileCountryCode?.value}
                        </td>{" "}
                        {/* Country Code */}
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_UnAuthorizedCountryCode
                          }
                        </td>
                      </tr>
                    ))}

                    {duplicateMobileNumbers.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{email.mobileNumber}</td> {/* Mobile Number */}
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_DuplicateMobileNum
                          }
                        </td>
                      </tr>
                    ))}
                    {missingMobileNumbers.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>
                          {email.mobileCountryCode?.value === undefined
                            ? email.mobileCountryCode
                            : email.mobileCountryCode?.value}
                        </td>{" "}
                        {/* Country Code */}
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_EnterAMobileNumber
                          }
                        </td>
                      </tr>
                    ))}
                    {missingCountryCodes.map((email, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{email.mobileNumber}</td> {/* Mobile Number */}
                        <td>
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_EnterACountryCode
                          }
                        </td>
                      </tr>
                    ))}
                    {(invalidCanPrintValues || []).map((row, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{row.invalidCanPrint}</td>
                        <td>{selectedLanguage.LstLanguageCodes.UI_InvalidCanPrintValue || "Invalid Can print option Please enter (TRUE or FALSE)."}</td>
                      </tr>
                    ))}
                    {(exceedMaxPrintsPerDoc || []).map((row, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{row.maxPrintsPerReader}</td>
                        <td>{selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument}</td>
                      </tr>
                    ))}
                    {(maxPrintsWithoutCanPrint || []).map((row, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{row.maxPrintsPerReader}</td>
                        <td>{"Can print should be enabled to configure Max allowed prints"}</td>
                      </tr>
                    ))}
                    {(canPrintNotEnabledAtDocLevel || []).map((row, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{row.email}</td>
                        <td>{"Can print must be enabled at the document level before it can be enabled for individual readers."}</td>
                      </tr>
                    ))}
                    {(maxPrintsExceedLimit || []).map((row, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{row.maxPrintsPerReader}</td>
                        <td>{"The maximum limit for Max prints per reader should be less than 10,000"}</td>
                      </tr>
                    ))}
                    {(invalidMaxPrintsValues || []).map((row, index) => (
                      <tr className="borderrow" key={index}>
                        <td>{counter++}</td>
                        <td>{row.invalidMaxPrints}</td>
                        <td>{"Max prints per reader must be a valid number."}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const getIssueText = (email, selectedLanguage) => {
  if (email.duplicate) return selectedLanguage.LstLanguageCodes.UI_DuplicateEmailAdress;
  if (email.emailLength) return selectedLanguage.LstLanguageCodes.UI_EmailAdressContainsMoreThan255;
  if (email.invalidWithoutDotCom) return selectedLanguage.LstLanguageCodes.UI_InvalidEmailAdress;
  if (email.localPartValidation) return selectedLanguage.LstLanguageCodes.UI_LocalPartofEmailContainsMorethan64;
  if (email.longDomain) return selectedLanguage.LstLanguageCodes.UI_DomainContainsMoreThan190;
  if (email.longFirstName) return selectedLanguage.LstLanguageCodes.UI_FirstNameMoreThanFifty;
  if (email.longLastName) return selectedLanguage.LstLanguageCodes.UI_LastNameMoreThanFifty;
  if (email.invalidMobileNumber) return selectedLanguage.LstLanguageCodes.UI_EnterValidMobileNum;
  if (email.unauthorizedCountryCode) return selectedLanguage.LstLanguageCodes.UI_UnAuthorizedCountryCode;
  if (email.duplicateMobile) return selectedLanguage.LstLanguageCodes.UI_DuplicateMobileNum;
  if (email.missingMobile) return selectedLanguage.LstLanguageCodes.UI_EnterAMobileNumber;
  if (email.missingCountryCode) return selectedLanguage.LstLanguageCodes.UI_EnterACountryCode;
  return "";
};

export default ValidationPopup;
